import { render, staticRenderFns } from "./MediaFileAddButton.vue?vue&type=template&id=ddd30018&scoped=true&"
import script from "./MediaFileAddButton.vue?vue&type=script&lang=ts&"
export * from "./MediaFileAddButton.vue?vue&type=script&lang=ts&"
import style0 from "./MediaFileAddButton.vue?vue&type=style&index=0&id=ddd30018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd30018",
  null
  
)

export default component.exports